// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'

function SearchSummary (props) {
  return (
    <div className='result-summary'>
      Displaying {props.totalCount.toLocaleString('en-US')}{' '}
      {pluralize('result', props.totalCount)} for&nbsp;
      <span className='highlight'>{props.searchTerm}</span>.{' '}
      {props.filterCount +
        ' ' +
        pluralize('filter', props.filtersApplied) +
        ' applied.'}
    </div>
  )
}

SearchSummary.propTypes = {
  totalCount: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired,
  filterCount: PropTypes.number.isRequired,
  filtersApplied: PropTypes.number.isRequired
}

export default SearchSummary
